var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "height": "100%"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-check"
  }), _c('h3', {
    staticClass: "tit mt-16 mt-lg-24 mb-8 mb-lg-16"
  }, [_vm._v("회원가입이 완료 되었습니다.")]), _c('p', {
    staticClass: "page-text--lg"
  }, [_vm._v(" 관리자 승인 후 기업서비스를 이용하실 수 있습니다"), _c('br'), _vm._v(" 1~2 영업일 이내에 승인여부를 확인 하실 수 있습니다 ")])]), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이전 화면으로 돌아가기")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, [_c('span', [_vm._v("대시보드로 가기")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }